import { style } from 'typestyle';
import './fonts/roboto/Roboto.css';
export const tinyCssProps = {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: '12px',
    fontWeight: 500,
    letterSpacing: -0.25,
};
export const tinyStyle = style(tinyCssProps);
export const smallStyle = style({
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '14px',
    letterSpacing: -0.25,
});
export const mediumStyle = style({
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '16px',
    letterSpacing: '-0.5px',
});
export const regularStyle = style({
    fontFamily: 'Roboto',
    fontSize: 14,
    lineHeight: '16px',
    letterSpacing: -0.5,
});
export const boldStyle = style({
    fontFamily: 'Roboto',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 'bold',
    letterSpacing: -0.2,
});
export const regularBold = style({
    fontFamily: 'Roboto',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 'bold',
    letterSpacing: -0.25,
});
export const bigStyle = style({
    fontFamily: 'Roboto',
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 500,
    letterSpacing: -0.2,
});
//# sourceMappingURL=text.js.map